import {Component, OnInit, NgZone, ViewChild, ElementRef, HostBinding, ChangeDetectorRef, Optional, Inject, LOCALE_ID} from '@angular/core';
import {DialogComponent} from "@farris/ui-dialog";
import {DatagridComponent} from "@farris/ui-datagrid";
import {ExprEditMode, ExpressionService, InjectedType} from "@gsp-svc/expression";
import {ProcessDesignerUIState} from "../../../../app/process-designer.uistate";
import {ActivityExecutorParticipant} from "./entities/activity-executor.participant";
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../../i18n/assets/lang.resource';

@Component({
  selector: 'app-activity-handler-performer',
  templateUrl: './activity-executor-performer.component.html',
  styleUrls: ['./activity-executor-performer.component.css'],
  providers: [
     WfLocalePipe,
  ]
})
export class ActivityExecutorPerformerComponent implements OnInit {
  @HostBinding('class')
  cls = 'd-flex flex-fill h-100';
  showClearButton = false;
  activityExecutors: ActivityExecutorParticipant[] = [];
  condition: string;
  cols = [
    { title: this.localePipe.transform('component.activityExecutor.name'), field: 'Name', width: 60 },
    { title: 'ID', field: 'Id', width: 90 }
  ];

  @ViewChild('inputGroup') inputGroup: ElementRef;
  @ViewChild('allActivityDialog') allActivityDialog: DialogComponent;
  @ViewChild('allActivityTable') allActivityTable: DatagridComponent;

  constructor(
    private ngZone: NgZone,
    public designerUIState: ProcessDesignerUIState,
    private expr: ExpressionService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.inputGroup.nativeElement.addEventListener(
        'mouseenter',
        this.onMouseEnter.bind(this)
      );
      this.inputGroup.nativeElement.addEventListener(
        'mouseleave',
        this.onMouseLeave.bind(this)
      );
    });
  }

  onMouseEnter(event) {
    this.showClearButton = true;
    if (this.showClearButton) {
      this.toggleClearIcon(event, true);
    }
  }
  onMouseLeave(event) {
    this.showClearButton = false;
    this.toggleClearIcon(event, false);
  }
  private toggleClearIcon(event: any, isShow = false) {
    const str = isShow ? '' : 'none';
    const clearIcon = event.target.querySelector('.input-group-clear');
    if (clearIcon) {
      clearIcon.style.display = str;
    }
  }
  clear(data: any) {
    this.activityExecutors = [];
  }
  selectUsers(data: any) {
    // 已办用户
    const selectedUser = [];
    if(this.activityExecutors && this.activityExecutors.length > 0){
      for(const handler of this.activityExecutors) {
        const data = {
          data: {
            Id: handler.activityDefId,
            Name: handler.activityDefName
          },
          id: handler.activityDefId
        }
        selectedUser.push(data);
      }
    }
    this.allActivityTable.setCurrentPagerData(selectedUser);
    this.allActivityDialog.show();
  }
  editConditon() {
    // this.expr.clearContext();
    if (this.designerUIState.schemas.length > 0) {
      for (const schema of this.designerUIState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerUIState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    let context = new Array();
    context = this.designerUIState.addContext(context);
    if (this.designerUIState.subActivityContext.length > 0) {
      for (const variable of this.designerUIState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.designerUIState.activityComponentContext.length > 0) {
      for (const variable of this.designerUIState.activityComponentContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    this.expr.setEditPattern(ExprEditMode.Conditional); // 表达式展现模式：默认简易版
    this.expr.addExpressionText(this.condition);
    this.expr.buildExpression().then((expressioninfo: string) => {
      this.condition = expressioninfo;
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

  activitiesSelect() {
    const selectedActivities = this.allActivityTable.checkeds;
    this.activityExecutors = selectedActivities.map(activity => {
      const handler = new ActivityExecutorParticipant(activity.data.Id, activity.data.Name, 'wf.ActivityExecutorParticipantExpression');
      handler.performerName = '<' + activity.data.Name + this.localePipe.transform('component.activityExecutor.eventHandler');
      handler.activityDefId = activity.data.Id;
      handler.activityDefName = activity.data.Name;
      handler.condition = this.condition;
      return handler;
    });
    this.allActivityDialog.close();
  }
  getPerformers() {
    this.activityExecutors.map(x => x.condition = this.condition);
    return this.activityExecutors;
  }
}
